import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "faq",
  class: "home-faq section"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "divider bg-primary section-divider mb-2" }, null, -1)
const _hoisted_4 = { class: "heading text-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "heading" }
const _hoisted_7 = {
  class: "answer xyz-in",
  xyz: "fade duration-8"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "heading" }
const _hoisted_10 = {
  class: "answer xyz-in",
  xyz: "fade duration-8"
}

import { strings } from '@/strings'
import Icon from '@/components/icons/icon.vue'
import { ref } from 'vue'

// faq tab active item index

export default /*#__PURE__*/_defineComponent({
  __name: 'home-faq',
  setup(__props) {

const active = ref(0)
//  faq item on select
const on_select = (i: number) => {
  active.value = i
}

const show_more = ref(false)
const on_show_more= () => {
  show_more.value = !show_more.value
}

const faq_data = [
  {
    heading: strings.faq[2],
    text: strings.faq[3]
  },
  {
    heading: strings.faq[4],
    text: strings.faq[5]
  },
  {
    heading: strings.faq[6],
    text: strings.faq[7]
  },
  {
    heading: strings.faq[8],
    text: strings.faq[9]
  },
  {
    heading: strings.faq[10],
    text: strings.faq[11]
  },
  {
    heading: strings.faq[12],
    text: strings.faq[13]
  },
  {
    heading: strings.faq[14],
    text: strings.faq[15]
  },
  {
    heading: strings.faq[16],
    text: strings.faq[17],
    link: {
      path: '/unsubscribe',
      text: strings.core["Unsubscribe"]
    }
  },
  {
    heading: strings.faq[18],
    text: strings.faq[19],
    link: {
      path: '/reset-password',
      text: strings.core["ResetPassword"]
    }
  }
]


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(strings).faq[1]), 1)
      ]),
      (show_more.value === true)
        ? (_openBlock(), _createElementBlock("div", {
            class: "faq-list mt-4",
            key: show_more.value
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(faq_data, (item, i) => {
              return _createElementVNode("div", {
                onClick: ($event: any) => (on_select(i)),
                class: _normalizeClass(["item card bg-white shadow-dark", {'active': active.value === i}])
              }, [
                _createElementVNode("h6", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(item.heading), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", null, _toDisplayString(item.text), 1),
                  (item.link)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "btn bg-light mt-1",
                        to: item.link.path
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.link.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_5)
            }), 64)),
            _createElementVNode("div", { class: "show-more text-center text-dark" }, [
              _createElementVNode("a", { onClick: on_show_more }, " Show Less ")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", {
            class: "faq-list mt-4",
            key: show_more.value
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n, i) => {
              return _createElementVNode("div", {
                key: i,
                onClick: ($event: any) => (on_select(i)),
                class: _normalizeClass(["item card bg-white shadow-dark", {'active': active.value === i}])
              }, [
                _createElementVNode("h6", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(faq_data[i].heading), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", null, _toDisplayString(faq_data[i].text), 1),
                  (faq_data[i].link)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "btn bg-light mt-1",
                        to: faq_data[i].link!.path
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(faq_data[i].link!.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_8)
            }), 64)),
            _createElementVNode("div", { class: "show-more text-center text-dark with-bg" }, [
              _createElementVNode("a", { onClick: on_show_more }, " Show more ")
            ])
          ]))
    ])
  ]))
}
}

})